<svg class="stroke-icon">
  <use attr.xlink:href="assets/svg/icon-sprite.svg#stroke-{{icons}}"></use>
</svg>
